import React, { useEffect, useRef, useState } from "react";
import { Header } from "../components/Common/Header";
// import { BlogCard1 } from "../components/Blogs/BlogCard1";
import { BlogCard2 } from "../components/Blogs/BlogCard2";
import { Title } from "../components/Common/Title";

import BgImage from "../assets/images/Headers/Blogs.webp";
import { PrimaryButton } from "../components/Common/PrimaryButton";

import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { trendingblogs } from "../data/Blogs/BlogPosts";

export const Blogs = () => {
  const scrollContainer = useRef(null);

  const worldposts = [
    {
      link: "https://www.forbes.com/councils/forbescoachescouncil/2024/07/22/building-your-coaching-business-conquering-economic-stress/",
      image:
        "https://imageio.forbes.com/specials-images/imageserve/669a5c4e15148ee8263898f5/Stressed-businessman/960x0.jpg?format=jpg&width=1440",
      title: "Building Your Coaching Business: Conquering Economic Stress",
      caption: "Forbes Coaches Council",
    },
    {
      link: "https://www.forbes.com/sites/lizkislik/2023/11/06/how-coaching-makes-a-difference-in-leadership-ability-and-satisfaction/",
      image:
        "https://imageio.forbes.com/specials-images/imageserve/6549afaa806655d590ac5372/Smiling-senior-executive-coach-in-discussion-with-her-client-in-conference-room/960x0.jpg?format=jpg&width=1440",
      title:
        "How Coaching Makes A Difference In Leadership Ability And Satisfaction",
      caption: "Forbes Coaches Council",
    },
    {
      link: "https://sumankher.com/2015/08/27/how-can-coaching-help-you/",
      image: "https://sumankher.com/wp-content/uploads/2015/08/coaching3.jpeg",
      title: "How Coaching Can Help You Achieve Life Changing Goals",
      caption: "Soft Skills Studio",
    },
    {
      link: "https://coachingfederation.org/blog/coaching-success",
      image:
        "https://emeritus.org/in/wp-content/uploads/sites/3/2022/09/business-manager.jpg.optimal.jpg",
      title:
        "How Senior Manager Buy-In Drives Coaching Success: A Personal Experience",
      caption: "By Kim Eusepi | December 11, 2024",
    },
    {
      link: "https://luisazhou.com/blog/coaching-statistics/#:~:text=In%20one%20study%2C%20executive%20coaching,Evidence%20Based%20Coaching%20and%20Mentoring",
      image:
        "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
      title: "Coaching Statistics: The ROI of Coaching in 2024",
      caption: "By Luisa Zhou",
    },
    {
      link: "https://www.growthspace.com/programs/cohort-based-learning",
      image:
        "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
      title: "Build skills together, drive team success",
      caption:
        "Interactive workshops that close knowledge gaps, boost performance, and ensure skills stick across your organization.",
    },
    {
      link: "https://globalwellnessinstitute.org/global-wellness-institute-blog/2024/05/24/the-benefits-of-coaching-on-employee-stress/#:~:text=Studies%20have%20demonstrated%20significant%20improvements,distress%20and%20burnout%20through%20coaching",
      image:
        "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
      title: "The Benefits of Coaching on Employee Stress",
      caption: "By Emma Carpenter",
    },
    {
      link: "https://rrgexec.com/blog/executive-coaching-results-recent-studies-show-up-to-700-return-on-investment/",
      image:
        "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
      title:
        "Executive Coaching Results: Recent Studies Show Up To 700% Return On Investment",
      caption: "Robinson Resource Group",
    },
    {
      link: "https://www.emerald.com/insight/content/doi/10.1108/jwam-04-2021-0030/full/html#:~:text=Meanwhile%2C%20Theeboom%20et%20al.',on%20employees'%20working%20life%20and",
      image:
        "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
      title:
        "A Meta-analysis of contemporary psychologically informed coaching approaches",
      caption: "",
    },
  ];

  const [visibleCount, setVisibleCount] = useState(3);

  const showMore = () => {
    setVisibleCount((prevCount) => prevCount + 3);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header image={BgImage} title="Our Resources" />

      {window.innerWidth > 767 ? (
        <div
          style={{
            padding: "50px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <div style={{display: "flex", justifyContent: "space-between"}}>
          <div>
            <p style={{ fontSize: "40px", textAlign: "left" }} data-aos="fade">
              Global Voices
            </p>
            <p
              style={{ fontSize: "16px", textAlign: "left", marginTop: "10px" }}
              data-aos="fade"
            >
              Connecting you to stories from every corner of the world
            </p>
          </div>

          <div style={{display: "flex", padding: "0px 20px", gap: "10px", justifyContent: "flex-end", alignItems: "flex-end"}}>
            <div>
              <PrimaryButton
                label={<FaArrowLeft />}
                onClick={() =>
                  scrollContainer.current.scrollBy({
                    left: -350,
                    behavior: "smooth",
                  })
                }
                style={{padding: "10px 15px", borderRadius: 10}}
              />
            </div>

            <div>
              <PrimaryButton
                label={<FaArrowRight />}
                onClick={() =>
                  scrollContainer.current.scrollBy({
                    left: 350,
                    behavior: "smooth",
                  })
                }
                style={{padding: "10px 15px", borderRadius: 10}}
              />
            </div>
            </div>
            </div>

          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                gap: "30px",
                overflow: "scroll",
                marginTop: "30px",
                overflowY: "hidden",
              }}
              ref={scrollContainer}
            >
              {worldposts.map((post, index) => (
                <a
                  href={post.link}
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none", color: "inherit" }}
                  key={index}
                >
                  <div
                    style={{
                      width: "350px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                    data-aos="fade"
                  >
                    <div
                      style={{
                        width: "100%",
                        aspectRatio: "2/1",
                        borderRadius: "8px",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                        src={post.image}
                        alt={post.title}
                      />
                    </div>

                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        lineHeight: "1.4",
                        width: "350px",
                      }}
                    >
                      {post.title}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            
          </div>

          
        </div>
      ) : (
        <div
          style={{
            padding: "50px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <div>
            <p
              style={{ fontSize: "40px", textAlign: "center" }}
              data-aos="fade"
            >
              Global Voices
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "center",
                marginTop: "10px",
              }}
              data-aos="fade"
            >
              Connecting you to stories from every corner of the world
            </p>
          </div>
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "50px",
            }}
          >
            {worldposts.slice(0, visibleCount).map((post, index) => (
              <a
                href={post.link}
                rel="noreferrer"
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div
                  style={{
                    width: "300px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0px 4px 12px 0px #00000026",
                    minWidth: "300px",
                    height: "100%",
                  }}
                  data-aos="fade"
                >
                  <img
                    style={{
                      width: "100%",
                      aspectRatio: "16/9",
                      objectFit: "cover",
                    }}
                    src={post.image}
                    alt={post.title}
                  />
                  <div
                    style={{
                      padding: "20px",
                      gap: "10px",
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {post.title}
                    </p>
                    <p style={{ fontSize: "16px", color: "#545454" }}>
                      {post.caption.length > 100
                        ? `${post.caption.slice(0, 100)}...`
                        : post.caption}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {visibleCount < worldposts.length && (
            <div style={{ textAlign: "center", marginTop: "30px" }}>
              <PrimaryButton label={"Show More"} onClick={showMore} />
            </div>
          )}
        </div>
      )}

      <div
        style={{
          padding: "50px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Title center={true} subtitle="CTB Blogs" />
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "50px",
          }}
        >
          {trendingblogs.map((blog, index) => (
            <BlogCard2
              id={blog.id}
              key={index}
              image={blog.image}
              title={blog.title}
              readtime={blog.readtime}
              category={blog.category}
              caption={
                blog.description.length > 150
                  ? `${blog.description.slice(0, 150)}...`
                  : blog.description
              }
            />
          ))}
        </div>
      </div>
    </>
  );
};